import html2canvas from "html2canvas";
import jsPDF from "jspdf";

/**
 * Exporta un flyer (HTML de email) a PDF o imagen. El HTML se renderiza en un
 * iframe off-screen al ancho del email (704px = 680 del contenido + padding del
 * wrapper) y se captura con html2canvas. Reusa las mismas libs que Presupuestos.
 */
const WIDTH = 704;

async function renderCanvas(html) {
  const iframe = document.createElement("iframe");
  Object.assign(iframe.style, {
    position: "fixed", left: "-10000px", top: "0", width: `${WIDTH}px`, height: "100px", border: "0", background: "#ececec",
  });
  iframe.setAttribute("aria-hidden", "true");
  document.body.appendChild(iframe);
  try {
    const doc = iframe.contentDocument;
    doc.open(); doc.write(html); doc.close();
    // Esperar la carga REAL de FT Habit e imágenes antes de capturar: si
    // html2canvas mide con la fuente fallback y pinta con la custom (o al
    // revés), los glifos salen pegados. Misma receta que deckExport.
    try { await doc.fonts.ready; } catch (_) {}
    await Promise.all(
      Array.from(doc.images).map((img) => (img.decode ? img.decode().catch(() => {}) : Promise.resolve()))
    );
    await new Promise((r) => setTimeout(r, 250));
    const h = Math.max(doc.body.scrollHeight, doc.documentElement.scrollHeight, 300);
    iframe.style.height = `${h}px`;
    return await html2canvas(doc.body, {
      scale: 2, backgroundColor: "#ececec", useCORS: true, windowWidth: WIDTH, width: WIDTH, height: h,
    });
  } finally {
    document.body.removeChild(iframe);
  }
}

export async function descargarFlyerPdf(html, filename) {
  const canvas = await renderCanvas(html);
  const w = canvas.width / 2; // volver a px CSS (el canvas es 2x)
  const h = canvas.height / 2;
  const pdf = new jsPDF({ unit: "px", format: [w, h], orientation: "portrait", hotfixes: ["px_scaling"] });
  pdf.addImage(canvas.toDataURL("image/jpeg", 0.95), "JPEG", 0, 0, w, h);
  pdf.save(filename);
}

export async function descargarFlyerImagen(html, filename) {
  const canvas = await renderCanvas(html);
  const a = document.createElement("a");
  a.href = canvas.toDataURL("image/png");
  a.download = filename;
  document.body.appendChild(a); a.click(); a.remove();
}
